import React from "react";
import classnames from "classnames";
import moment from 'moment';

import { connect } from "react-redux";
import { Converter } from "@/helpers/functions";
import { getElementWidthHeightById } from "@/helpers/global";
import { chartingConfigs } from '@/configurations/app-configs/app.setting.config';
import { stockActions } from "@/actions/trading/stock.action";
import { ACTION_TYPE } from "@/constants/w-socket";
import { ENDPOINT_REQUEST } from "@/configurations";
import { stockServices } from '@/services/trading-services/stock.services'

import "@/assets/styles/components/charting.scss";

class InstrumentLightweightCharts extends React.Component {
    constructor(props) {
        super(props)
        this.resources = Promise.all([
          import('@/assets/ttl_chart_lib/vendor.1d4c06ac'),
          import('@/assets/ttl_chart_lib/TTLStockChart_MobileApp.ba94aa5b'), 
          import('@/assets/ttl_chart_lib/TTLStockChart_MobileApp.3e89e081.css'),
        ])
        this.chartMethod = null
    }

    render() {

        const { language, chart_id, isMinimize, rangeSwitcherEnabled, styles } = this.props;
        return (
            <React.Fragment>
                <div id="charts-container" className="charts-container">
                    {/* <div id="chart-header-container" className={classnames("chart-header", isMinimize && "minimize-size")}>
                      <div className="range-switcher">
                        <span className="pointer back-icon" onClick={() => this.props.onMinimize()}>{language.common_back}</span>
                      </div> */}
                       {/* {rangeSwitcherEnabled && <div className="range-switcher">
                            {!isMinimize && iTradeEnv?.pages?.market?.init?.isOpenPieChart && <span className="pointer back-icon" onClick={() => this.props.onMinimize()}>{language.common_back}</span>}
                            <ul>
                                {ranges.map(range => {
                                    return (
                                        <li className={classnames("pointer", currentRange === range.resolution && 'active')}
                                        onClick={() => this.onRangeSwitcher(range.resolution)}
                                        key={range.id}>{language[range.label]}</li>
                                    )
                                })}
                            </ul>
                        </div>}
                        {isMinimize && <span className="pointer back-icon" onClick={() => this.props.onMaximize()}>{language.common_chart_detail}</span>} */}
                    {/* </div> */}
                    <div id="chart-inner" className="chart-content">
                        <div id={chart_id} className="chart-content-data" style={styles}></div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
    componentDidMount() {
      this.resources.then(() => this.renderChart())
        // this.getHistoricalData();

    }

    componentDidUpdate(prevProps) {
        const currentInstrument = Converter.mappingStockCode(this.props.marketParams.stockCode);
        const currentExchangeID = Converter.mappingWebSocketMarket(this.props.marketParams.marketID)
        const prevInstrument = Converter.mappingStockCode(prevProps.marketParams.stockCode);
        if(currentInstrument !== prevInstrument && currentInstrument && currentExchangeID) {
            if (this.chartMethod) {
              this.chartMethod.setSymbol({
                exchangeID: currentExchangeID,
                key: currentInstrument
              })
            }
        }
        if (this.props.theme !== prevProps.theme) {
          this.onChangeChartLayout();
        }
        if (this.props.language !== prevProps.language) {
            this.onChangeChartLocale();
        }
    }

    componentWillUnmount() {
        this.setState = () => {
          return
        }
        this.chartMethod && (this.chartMethod = null)
      }
    
    getHistoricalData = () => {
        const { marketParams } = this.props;
        if(marketParams.marketID && marketParams.stockCode) {
            let p = {
                msgType: ACTION_TYPE.HISTORICAL_DATA,
                sessID: this.props.mdsToken,
                symbol: {
                    exchangeID: Converter.mappingWebSocketMarket(marketParams.marketID),
                    key: Converter.mappingStockCode(marketParams.stockCode)
                },
                period: this.state.currentRange,
                startTime: moment().subtract(3, 'days').format('YYYY-MM-DD HH:mm:ss'),
                endTime: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
            }

            this.chartMethod && this.chartMethod.setSymbol(p.symbol)

            // this.props.getHistoricalData(p, res => {
            //   if(res && res.points) {
            //     const { data, header } = res.points;
            //     this.setChartData(data);
            //   } else {
            //     this.setChartData([]);
            //   }
            // })
        }
    }

    calcChartWrapper = () => {
        const { isMinimize } = this.props;
        let height = 0;
        const pXY = 80;
        const totalWH = getElementWidthHeightById("charts-container");
        const totalChartHeaderWH = getElementWidthHeightById("chart-header-container");
        if(totalWH && totalChartHeaderWH && totalWH.height > 0 && totalChartHeaderWH.height > 0) {
            if(isMinimize) {
                height = totalWH.height - totalChartHeaderWH.height - pXY - 10;
            } else {
                height = totalWH.height - totalChartHeaderWH.height * 2 - pXY - 50;
            }
        } else {
            height = this.props.cHeight;
        }
        return { height };
    }

    onRangeSwitcher(range) {
        if(range === this.state.currentRange) return;
        this.setState({ currentRange: range })
    }

    onChangeChartLayout = () => {
        const { theme, isMobile } = this.props;
        this.chartMethod.changeLayout(theme.charAt(0).toUpperCase() + theme.slice(1), isMobile);
    }

    onChangeChartLocale = () => {
        const { language } = this.props;
        const locale = language.locale;
        this.chartMethod.setLocale(Converter.mappingWinVestChartLanguage(locale))
    }

    setChartData = (chartData) => {
        if(this.chartMethod) this.chartMethod.drawChart({data: chartData});
    }
    renderChart = (chartData = {data: []}) => {
        const { theme, language, isMinimize, chart_id, isMobile, volumeEnabled, stockSetting, marketParams, mdsToken } = this.props;
        const locale = language.locale
        let upColor = '';
        let downColor = '';
        let colorAppSetting = 'rise-green,fall-red'.split(',');
        colorAppSetting.map(x => {
            let fieldName = '';
            if(x.includes('-r')) {
                fieldName = x.replace('-r', 'R');
            } else if(x.includes('-g')){
                fieldName = x.replace('-g', 'G');
            }

            if(x.includes('fall')) {
                downColor = chartingConfigs.dark.color[fieldName];
            } else {
                upColor = chartingConfigs.dark.color[fieldName];
            }
        })
        if(chart_id) {
          setTimeout(() => {
            this.chartMethod = new TTLStockChart(this.props.chart_id, ENDPOINT_REQUEST.wsSTOCK.SNAPSHOT , stockServices.enquireInstrumentInfo)
            this.chartMethod.drawChart()
            this.chartMethod.setWSSessionID(mdsToken)
            this.chartMethod.setSymbol({
              exchangeID: Converter.mappingWebSocketMarket(marketParams.marketID),
              key: Converter.mappingStockCode(marketParams.stockCode)
            })
            this.chartMethod.setChartControlConfigurable(false);
            this.chartMethod.setChartType("IntraDay");
            this.chartMethod.setToggleYAxisPercentageBased(true);
            this.chartMethod.importState(['Candle', [['InChartSMA', [5, 10, 20, 30, 60]]], [["Vol", [], 50]]])
            // this.chartMethod.setAreaSeriesStyling(chartingConfigs.areaSeries);
            this.chartMethod.changeLayout(theme.charAt(0).toUpperCase() + theme.slice(1), isMobile);
            this.chartMethod.setLocale(Converter.mappingWinVestChartLanguage(locale));
            this.chartMethod.setUpColor(upColor);
            this.chartMethod.setDownColor(downColor);
            chart_id==="dialog-chart"?this.chartMethod.setChartHeight(650):""
            // this.chartMethod.setGlobalFormatters(chartingConfigs.dateFormat);
            if(!isMobile) {
              this.chartMethod.setHoverTooltipConfig(true)
            }
          }, 500)
        }
    }
}

InstrumentLightweightCharts.defaultProps = {
    chart_id: 'chart-data',
    isMinimize: false,
    rangeSwitcherEnabled: true,
    cWidth: 0,
    cHeight: 0,
    volumeEnabled: true,
    styles: {},
    chartType: 'Area',
    inChartData: [],
    inChartType: '',
    subChartData: [],
    subChartType: '',
}

export default connect(
    (state) => ({
        isMobile: state.app.isMobile,
        language: state.app.language,
        theme: state.app.theme,
        currentTradingAccount: state.trade.currentTradingAccount,
        instrumentInfo: state.trade.instrumentInfo,
        stockSetting: state.app.stockSetting,
        marketParams: state.trade.marketParams,
        mdsToken: state.trade.mdsToken,
    }),
    (dispatch) => ({
        getHistoricalData: (p, res) => dispatch(stockActions.getHistoricalData(p, res))
    })
)(InstrumentLightweightCharts);
